module.exports = __webpack_public_path__ + "img/topicThree_n.18a83dab.svg";